export type AdminOrderStatus = 'payment_pending' | 'pending' | 'processing' | 'on_way' | 'delivered' | 'cancelled';

export interface AdminOrderItem {
  name: string;
  qty: number;
  price: number;
}

export interface AdminOrder {
  id: string;
  customer: string;
  phone: string;
  address: string;
  items: AdminOrderItem[];
  total: number;
  status: AdminOrderStatus;
  paymentMethod: string;
  createdAt: string;
  rider?: string;
  note?: string;
  cashAmount?: number;
  changeAmount?: number;
  userId?: string;
}

export const adminOrders: AdminOrder[] = [
  {
    id: 'SDG-20861',
    customer: 'Kwame Thomas',
    phone: '+592-611-2034',
    address: '12 Regent Street, Georgetown',
    items: [
      { name: 'Banks Beer', qty: 6, price: 5100 },
      { name: 'Coca-Cola 500ml', qty: 2, price: 600 },
    ],
    total: 5700,
    status: 'pending',
    paymentMethod: 'Cash on Delivery',
    createdAt: '2026-03-22T08:12:00',
  },
  {
    id: 'SDG-20860',
    customer: 'Priya Ramkhelawan',
    phone: '+592-622-8811',
    address: '88 Church Street, Georgetown',
    items: [
      { name: 'El Dorado Rum 750ml', qty: 1, price: 4500 },
      { name: 'Heineken 330ml', qty: 4, price: 4000 },
    ],
    total: 8500,
    status: 'processing',
    paymentMethod: 'Credit Card',
    createdAt: '2026-03-22T07:55:00',
    rider: 'Marcus Johnson',
  },
  {
    id: 'SDG-20859',
    customer: 'Deon Clarke',
    phone: '+592-600-4422',
    address: '5 Vlissengen Road, Georgetown',
    items: [
      { name: 'Corona Extra 355ml', qty: 3, price: 3150 },
      { name: 'Red Bull Energy', qty: 2, price: 1900 },
    ],
    total: 5050,
    status: 'on_way',
    paymentMethod: 'Credit / Debit Card',
    createdAt: '2026-03-22T07:30:00',
    rider: 'Troy Williams',
  },
  {
    id: 'SDG-20858',
    customer: 'Anita Persaud',
    phone: '+592-615-7700',
    address: '23 Brickdam, Georgetown',
    items: [
      { name: 'D\'Vine Sorrel Wine', qty: 2, price: 5600 },
      { name: 'Pure Water Pack', qty: 1, price: 450 },
    ],
    total: 6050,
    status: 'delivered',
    paymentMethod: 'Cash on Delivery',
    createdAt: '2026-03-22T06:00:00',
    rider: 'Marcus Johnson',
  },
  {
    id: 'SDG-20857',
    customer: 'Ricardo Ferreira',
    phone: '+592-609-3355',
    address: '64 Main Street, Georgetown',
    items: [
      { name: 'Stag Beer 330ml', qty: 6, price: 4680 },
    ],
    total: 4680,
    status: 'delivered',
    paymentMethod: 'Cash on Delivery',
    createdAt: '2026-03-21T21:10:00',
    rider: 'Keisha Brown',
  },
  {
    id: 'SDG-20856',
    customer: 'Sharifa Ali',
    phone: '+592-630-1923',
    address: '9 Hadfield Street, Georgetown',
    items: [
      { name: 'Heineken 330ml', qty: 2, price: 2000 },
      { name: 'Carib Lager 330ml', qty: 3, price: 2250 },
      { name: 'Coca-Cola 500ml', qty: 2, price: 600 },
    ],
    total: 4850,
    status: 'cancelled',
    paymentMethod: 'Credit Card',
    createdAt: '2026-03-21T19:45:00',
    note: 'Customer requested cancellation',
  },
  {
    id: 'SDG-20855',
    customer: 'Omari Narine',
    phone: '+592-641-0077',
    address: '31 Camp Street, Georgetown',
    items: [
      { name: 'El Dorado Rum 750ml', qty: 2, price: 9000 },
      { name: 'Banks Beer', qty: 12, price: 10200 },
    ],
    total: 19200,
    status: 'delivered',
    paymentMethod: 'Credit Card',
    createdAt: '2026-03-21T17:20:00',
    rider: 'Troy Williams',
  },
  {
    id: 'SDG-20854',
    customer: 'Latoya Singh',
    phone: '+592-618-5500',
    address: '77 Waterloo Street, Georgetown',
    items: [
      { name: 'Red Bull Energy', qty: 4, price: 3800 },
      { name: 'Pure Water Pack', qty: 2, price: 900 },
    ],
    total: 4700,
    status: 'processing',
    paymentMethod: 'Credit / Debit Card',
    createdAt: '2026-03-21T16:05:00',
    rider: 'Keisha Brown',
  },
  {
    id: 'SDG-20853',
    customer: 'Jason Gonsalves',
    phone: '+592-605-2201',
    address: '14 Cummings Street, Georgetown',
    items: [
      { name: 'Corona Extra 355ml', qty: 6, price: 6300 },
      { name: 'D\'Vine Sorrel Wine', qty: 1, price: 2800 },
    ],
    total: 9100,
    status: 'pending',
    paymentMethod: 'Cash on Delivery',
    createdAt: '2026-03-21T14:30:00',
  },
  {
    id: 'SDG-20852',
    customer: 'Monique Duncan',
    phone: '+592-633-8844',
    address: '2 New Garden Street, Georgetown',
    items: [
      { name: 'Carib Lager 330ml', qty: 4, price: 3000 },
      { name: 'Stag Beer 330ml', qty: 4, price: 3120 },
    ],
    total: 6120,
    status: 'delivered',
    paymentMethod: 'Cash on Delivery',
    createdAt: '2026-03-21T12:15:00',
    rider: 'Marcus Johnson',
  },
  {
    id: 'SDG-20851',
    customer: 'Nikhil Ramdas',
    phone: '+592-627-6600',
    address: '56 Peter Rose Street, Georgetown',
    items: [
      { name: 'Banks Beer', qty: 3, price: 2550 },
      { name: 'Coca-Cola 500ml', qty: 3, price: 900 },
    ],
    total: 3450,
    status: 'cancelled',
    paymentMethod: 'Credit Card',
    createdAt: '2026-03-21T10:00:00',
    note: 'Address not found',
  },
  {
    id: 'SDG-20850',
    customer: 'Chantal Barrow',
    phone: '+592-644-3311',
    address: '38 Thomas Street, Georgetown',
    items: [
      { name: 'El Dorado Rum 750ml', qty: 1, price: 4500 },
      { name: 'Red Bull Energy', qty: 6, price: 5700 },
    ],
    total: 10200,
    status: 'delivered',
    paymentMethod: 'Credit / Debit Card',
    createdAt: '2026-03-20T20:40:00',
    rider: 'Keisha Brown',
  },
];
